var map = {
	"./BrandDetailsPageExtensions": 58391,
	"./BrandDetailsPageExtensions.ts": 58391,
	"./CheckoutShippingPageExtensions": 3472,
	"./CheckoutShippingPageExtensions.ts": 3472,
	"./CompactHeaderExtensions": 81301,
	"./CompactHeaderExtensions.ts": 81301,
	"./FooterExtensions": 18634,
	"./FooterExtensions.ts": 18634,
	"./HeaderExtensions": 95148,
	"./HeaderExtensions.ts": 95148,
	"./HomePageExtensions": 28805,
	"./HomePageExtensions.ts": 28805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79830;